module.exports = ".jumbotron, container {\n  padding-top: 10px; }\n"